import apiService from '../services/api/apiService'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export interface FeatureFlags {
  isClassificationEnabled: boolean
}

const initialState: FeatureFlags = {
  isClassificationEnabled: false
}

export interface ClassificationFlagParams {
  state: boolean
}

export const ACTION_FETCH_CLASSIFICATION_FLAG = 'classificationFlag/fetch'
export const fetchClassificationFlag = createAsyncThunk(
  ACTION_FETCH_CLASSIFICATION_FLAG,
  async () => {
    return await apiService.getClassificationFlag()
  }
)

export const ACTION_UPDATE_CLASSIFICATION_FLAG = 'classificationFlag/update'
export const updateClassificationFlag = createAsyncThunk(
  ACTION_UPDATE_CLASSIFICATION_FLAG,
  async (params: ClassificationFlagParams) => {
    return await apiService.putClassificationFlag(params)
  }
)

const classificationEngineSlice = createSlice({
  name: 'classificationEngine',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchClassificationFlag.fulfilled, (state, { payload }) => {
      state.isClassificationEnabled = payload.status
    }),
      builder.addCase(updateClassificationFlag.fulfilled, (state, { payload }) => {
        state.isClassificationEnabled = payload.status
      })
  }
})

export default classificationEngineSlice.reducer
